module.exports = __webpack_public_path__ + "img/ic-list-selected.3d9f2e7a.svg";